module.exports = __webpack_public_path__ + "img/7989af920d5a80ed0ea3969935c56e63.4ee066a4.jpg";